import React, { FC, useState } from 'react';
import { css } from '@emotion/css';
import { Theme } from 'evcharging/app/themes';
import useTheme from 'evcharging/hooks/useTheme';

export interface FaqItemProps {
  question: string;
  answer: string;
}

const FaqItem: FC<FaqItemProps> = (props) => {
  const { question, answer } = props;
  const [open, setOpen] = useState<boolean>(false);
  const theme = useTheme();
  const styles = createStyles(theme, { open });
  const onToggle = () => setOpen(!open);

  return (
    <div className={styles.root}>
      <button className={styles.button} type="button" onClick={onToggle}>
        {question}
        <span className={styles.icon}></span>
      </button>
      <div
        className={styles.body}
        dangerouslySetInnerHTML={{
          __html: answer,
        }}
      />
    </div>
  );
};

const createStyles = (theme: Theme, { open }: { open: boolean }) => ({
  root: css`
    padding: 32px;
    margin-bottom: 24px;
    border: 1px solid #b0babf;
    background: white;
    border-radius: 6px;
    ${theme.breakpoints.mobile.down} {
      padding: 18px;
    }
    h2 {
      margin-top: 32px;
      margin-bottom: 16px;
    }
  `,
  button: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: auto;
    width: 100%;
    border: none;
    padding: 0;
    text-align: left;
    background: transparent;
    outline: none;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #303940;
    cursor: pointer;
  `,
  body: css`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #6e7c87;
    height: 0;
    opacity: 0;
    visibility: hidden;
    ${open &&
    `
    height: auto;
    opacity: 1;
    visibility: visible;
    padding-top: 24px;
    `}

    ol, ul {
      padding-top: 18px;
      padding-left: 24px;
    }

    a {
      color: inherit;
    }
  `,
  icon: css`
    height: 17px;
    width: 30px;
    margin-top: 5px;
    margin-left: 20px;
    background: ${open
        ? `url("data:image/svg+xml,%3Csvg width='18' height='2' viewBox='0 0 18 2' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17 1H1' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E%0A")`
        : `url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 17V9M9 9V1M9 9H17M9 9H1' stroke='%23303940' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E%0A")`}
      center no-repeat;
  `,
});

export default FaqItem;
